import React from 'react';
import { theme } from '@/styles';
import { ApartRanks } from '@/types';
import GridListBox from '@/ui/GridListBox';
import AptRankIcon from '@/ui/Icons/AptRankIcon';
import { VStack, Text, Icongraphy } from '@design-system/pc';
import styled from 'styled-components';

interface AptRankProps {
  data: ApartRanks[];
  title: string;
}

const AptRank = ({ title, data }: AptRankProps) => {
  return (
    <GridListBox
      title={title}
      gridNum={3}
      amountNum={data.length}
      isAmount
      imgList={data}
      disabled={data.length < 4}
      gtmName="shop_most_construction_apart"
    >
      {({ item, index }: any) => (
        <AptRankCard
          background="color_chip.white"
          border="1px solid"
          borderColor="color_chip.gray.100"
        >
          {/*           <Apartment48Icon /> */}
          <Icongraphy
            variant="ic_apartment_custom_point_gray"
            size={48}
            resize
          />
          <RankIcon>
            <AptRankIcon
              fill={
                item.rank <= 3
                  ? '#FFF3B2'
                  : theme.colors.neutral_colors.gray[100]
              }
            >
              {item.rank}
            </AptRankIcon>
          </RankIcon>
          <AptRankCardPosition variant="subtitle6" color="color_chip.primary">
            {item.area}
          </AptRankCardPosition>
          <AptRankCardName variant="body2" color="color_chip.gray.600">
            {item.apart}
          </AptRankCardName>
        </AptRankCard>
      )}
    </GridListBox>
  );
};

export default AptRank;

const AptRankCard = styled(VStack)`
  position: relative;
  padding-top: 39px;
  align-items: center;
  padding-left: 42px;
  padding-right: 42px;
  width: 100%;
  height: 180px;
  border-radius: 2px;
`;

const AptRankCardName = styled(Text)``;

const AptRankCardPosition = styled(Text)`
  margin-top: 8px;
  margin-bottom: 4px;
`;

const RankIcon = styled.div`
  position: absolute;
  left: 16px;
  top: 0px;
`;
